

import "validate.js";
import "jquery-ajax-unobtrusive";
import "jquery-validation-unobtrusive";


// WEBPACK FOOTER //
// ./scripts/base.js